export default __webpack_public_path__ + "static/available-dogs-banner-bg-57b7fafec5cbe629aae3d6a298d8ebca.jpg";